import { createIcons, Brain, Compass, LayoutGrid, Hash, Type, Calculator, Hammer, Crosshair } from 'lucide'

createIcons({ icons: { Brain, Compass, LayoutGrid, Hash, Type, Calculator, Hammer, Crosshair } })

// Persist the chosen language into the React app's locale store before navigating
const lang = document.documentElement.lang || 'el'
document.querySelectorAll('a[href^="/app"]').forEach((link) => {
  link.addEventListener('click', () => {
    localStorage.setItem('kids-locale', JSON.stringify({ state: { locale: lang }, version: 0 }))
  })
})
